import { RouteObject } from "react-router";
import AgroManagerCallbackHandler from "./SsoCallbackHandler";

const routes: RouteObject = {
  id: "agromanager_sso_callback",
  path: "/agromanager_sso_callback",
  Component: AgroManagerCallbackHandler,
};

export default routes;
